import React from 'react';
import ReactTable from "react-table";
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import * as Fields from '../../../lis-shared/lis-layout/components/lis-forms-component';
import { committeeActionCreators } from '../../../stores/lis-committee-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { calendarActionCreators } from '../../../stores/lis-calendar-store';
import { minutesActionCreators } from '../../../stores/lis-minutes-store';
import { authActionCreators } from '../../../stores/lis-auth-store';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import DatePicker from "react-datepicker";
import { cancelRequest } from '../../../services/request.service';
import { scheduleActionCreators } from '../../../stores/lis-schedule-store';

const selectStyles = {
    control: (base, state) => ({
        ...base,
        height: '32px',
        fontSize: ".8em"
    }),
    menu: (base) => ({
        ...base,
        boxShadow: 'none',
        fontSize: ".8em",
        zIndex: 999
    }),
};

class ChairReportGrid extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoaded: true,
            sessionOptions: [],
            committeeOptions: [],
            chairReportList: [],
            chairReportDate: '',
            selectedSession: '',
            selectedCommittee: { value: undefined, label: "Committee" }
        }

        this.getCommittees = this.getCommittees.bind(this);
        this.getChairReports = this.getChairReports.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSessionSelectChange = this.handleSessionSelectChange.bind(this);
        this.handleCommitteeSelectChange = this.handleCommitteeSelectChange.bind(this);
        this.setParams = this.setParams.bind(this);
    }

    handleSessionSelectChange(value) {
        this.setState({
            selectedSession: value,
            selectedCommittee: { value: undefined, label: "Committee" },
            chairReportDate: '',
            chairReportList: []
        }, () => {
            this.getCommittees(value);
            this.getChairReports();
            localStorage.setItem('CHAIR_PARAMS', JSON.stringify({
                selectedSession: this.state.selectedSession
            }));
        });
    }

    handleCommitteeSelectChange(value) {
        this.setState({
            selectedCommittee: value ? value : { value: undefined, label: "Committee" },
        }, () => {
            this.getChairReports();
            this.setParams();
        })
    }

    handleDateChange(value) {
        this.setState({
            chairReportDate: value
        }, () => {
            this.getChairReports();
            this.setParams();
        });
    }

    componentDidMount() {
        let params = JSON.parse(localStorage.getItem('CHAIR_PARAMS'));
        if (params) {
            this.setState({
                selectedSession: params.selectedSession,
                selectedCommittee: params.selectedCommittee ? params.selectedCommittee : { value: undefined, label: "Committee" },
                chairReportDate: params.chairReportDate ? moment(params.chairReportDate) : ''
            }, () => {
                this.getChairReports();
                this.getCommittees(params.selectedSession, true);
            })
        }

        this.props.actions.getSessionList()
            .then(() => {
                //Format data for dropdown
                const sessionList = [...this.props.session.sessionList];
                let selectedSession;
                sessionList.forEach(session => {
                    session.value = session.SessionID;
                    session.label = session.SessionYear + ' ' + session.DisplayName;
                    // Select default session if one is not already selected
                    if (session.IsDefault && !params?.selectedSession) {
                        this.setState({
                            selectedSession: session
                        }, () => {
                            this.getCommittees(session, true);
                            this.getChairReports();
                        });
                    }
                });
                this.setState({
                    sessionOptions: sessionList.reverse()
                });
            });
    }

    componentWillUnmount() {
        cancelRequest();
    }

    getCommittees(session, init) {
        //Get the committee list based off the session data
        this.props.actions.getCommitteeList('sessionID=' + session.SessionID + "&includesubcommittees=true")
            .then(() => {
                let committees = [...this.props.committee.committeeList]
                let filteredCommittees = [];
                committees.forEach(committee => {
                    if (committee.ChamberCode === 'S') {
                        committee.label = committee.Name;
                        committee.value = committee.CommitteeID;

                        filteredCommittees.push(committee);
                    }
                });

                this.setState({
                    committeeOptions: filteredCommittees,
                    selectedCommittee: !init ? { value: undefined, label: "Committee" } : this.state.selectedCommittee,
                    isLoaded: true
                });
            });
    }

    getChairReports() {
        this.setState({
            isLoaded: false,
            chairReportList: []
        }, () => {
            const chairReportParams = "?sessionID=" + this.state.selectedSession.SessionID
                + (this.state.selectedCommittee.value ? "&committeeID=" + this.state.selectedCommittee.CommitteeID : "")
                + (this.state.chairReportDate ? "&minutesDate=" + moment(this.state.chairReportDate).format("YYYY-MM-DD") : "")

            this.props.actions.getChairReportList(chairReportParams)
                .then(() => {
                    this.setState({
                        isLoaded: true,
                        chairReportList: this.props.minutes.chairReportList.length > 0 ? [...this.props.minutes.chairReportList].filter(x => x.CommitteeNumber.includes("S")) : []
                    });
                });
        });
    }

    setParams() {
        localStorage.setItem('CHAIR_PARAMS', JSON.stringify({
            selectedSession: this.state.selectedSession,
            selectedCommittee: this.state.selectedCommittee,
            chairReportDate: this.state.chairReportDate
        }));
    }

    render() {
        return (
            <div className='dlas-forms'>
                <div className="header-half">
                    <h1>Chair Reports</h1>
                </div>

                <div className="toolbar inner-grid four chair-report-toolbar">
                    <div>
                        <Select
                            key={'session'}
                            value={this.state.selectedSession}
                            options={this.state.sessionOptions}
                            placeholder="Session"
                            id="sessionDropdown"
                            onChange={this.handleSessionSelectChange}
                            styles={selectStyles}
                        />
                    </div>
                    <div>
                        <Select
                            key={'committee'}
                            value={this.state.selectedCommittee}
                            placeholder="Committee"
                            options={this.state.committeeOptions}
                            id="committeeDropdown"
                            onChange={this.handleCommitteeSelectChange}
                            styles={selectStyles}
                            isClearable
                        />
                    </div>
                    <div>
                        <DatePicker
                            selected={this.state.chairReportDate}
                            onChange={this.handleDateChange}
                            isClearable
                        />
                    </div>
                </div>
                <ReactTable
                    resizable={false}
                    data={this.state.chairReportList}
                    loading={!this.state.isLoaded}
                    ref={r => this.reactTable = r}
                    columns={[
                        {
                            Header: "Date",
                            accessor: "",
                            width: 100,
                            Cell: row => {
                                return moment(row.original.MinutesDate).tz('America/New_York').format("MM/DD/YYYY");
                            }
                        },
                        {
                            Header: "Committee",
                            accessor: "CommitteeNumber",
                            Cell: row => {
                                return this.state.committeeOptions.find(committee => committee.CommitteeNumber === row.original.CommitteeNumber)?.Name || "";
                            }
                        },
                        {
                            Header: "Chair Report",
                            accessor: "",
                            width: 100,
                            Cell: row => {
                                return <a style={{ marginLeft: "45%" }} className="icon book" href={"/session-details/" + this.state.selectedSession.SessionCode + "/committee-information/" + row.original.CommitteeNumber + "/meetings/" + row.original.MinutesBookID + "/2"} ></a>
                            }
                        },
                    ]}
                    defaultPageSize={15}
                    pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
                    className="committee-table -striped -highlight"
                />
                <br />

            </div>
        );
    }
}

export default connect(
    (state) => {
        const { minutes, session, committee, login } = state;
        return {
            minutes,
            session,
            committee,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, committeeActionCreators, sessionActionCreators, calendarActionCreators, authActionCreators, scheduleActionCreators, minutesActionCreators), dispatch)
        }
    }
)(ChairReportGrid)